import styled from 'styled-components/macro'

const Popup = styled.div`
  position: absolute;
  top: ${(props) =>
    props.mobileTop
      ? `calc(${props.mobileTop}% + 12px)`
      : 'calc(-100% + 12px)'};
  width: 100%;
  background: ${(props) =>
    props.white ? '#fff' : props.theme.colors.grey.grey9};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;

  &:after {
    content: '';
    position: absolute;
    top: calc(100% - 7px);
    border-radius: 2px;
    left: calc(50% - 5px);
    transform: translate(-50%, 0%);
    width: 10px;
    height: 10px;
    background: ${(props) =>
      props.white ? '#fff' : props.theme.colors.grey.grey9};
    transform: rotate(45deg);
  }

  @media only screen and (min-width: 768px) {
    top: calc(-100% + 12px);
  }
`

const PopupLeft = styled(Popup)`
  @media only screen and (min-width: 768px) {
    &:after {
      transform: translate(0, 0%) rotate(45deg);
      left: 20px;
    }
  }
`

const PopupRight = styled(Popup)`
  top: calc(10% + 12px);

  @media only screen and (min-width: 768px) {
    &:after {
      left: auto;
      transform: translate(0%, 0%) rotate(45deg);
      right: 20px;
    }
  }
`

const PopupText = styled.p`
  color: ${(props) =>
    props.white
      ? props.theme.colors.grey.grey9
      : props.theme.colors.grey.white};
  font-family: 'Pluto Sans', sans-serif;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
  margin-top: 8px;
`

export { Popup, PopupLeft, PopupRight, PopupText }
